import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const DataContext = createContext(null);
export const useData = () => useContext(DataContext);

export function DataProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [works, setWorks] = useState([]);
  const [beforeAfter, setBeforeAfter] = useState([]);
  const [zones, setZones] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [blog, setBlog] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [guides, setGuides] = useState([]);
  const [guideCategories, setGuideCategories] = useState([]);
  const [localPages, setLocalPages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [s, sv, w, ba, z, f, b, r, g, gu, gc, lp] = await Promise.all([
        api.get("/settings"),
        api.get("/content/services"),
        api.get("/content/works"),
        api.get("/content/before-after"),
        api.get("/content/zones"),
        api.get("/content/faqs"),
        api.get("/content/blog"),
        api.get("/content/reviews"),
        api.get("/content/gallery"),
        api.get("/content/guides"),
        api.get("/content/guide-categories"),
        api.get("/content/local-pages"),
      ]);
      setSettings(s.data);
      setServices(sv.data);
      setWorks(w.data);
      setBeforeAfter(ba.data);
      setZones(z.data);
      setFaqs(f.data);
      setBlog(b.data);
      setReviews(r.data);
      setGallery(g.data);
      setGuides(gu.data);
      setGuideCategories(gc.data);
      setLocalPages(lp.data);
    } catch (e) {
      console.error("data load error", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const waLink = (msgKey = "whatsapp_msg") => {
    if (!settings) return "https://wa.me/393489904574";
    const msg = settings[msgKey] || settings.whatsapp_msg;
    return `${settings.whatsapp}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <DataContext.Provider value={{
      settings, services, works, beforeAfter, zones, faqs, blog, reviews, gallery, guides, guideCategories, localPages,
      loading, reload: load, waLink,
    }}>
      {children}
    </DataContext.Provider>
  );
}
